import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "SalesAnalysis"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", { d: "M2.25 3.77333C2.25 2.79395 3.0335 2 4 2H20C20.9665 2 21.75 2.79395 21.75 3.77333V15.4267H20.25V3.77333C20.25 3.63342 20.1381 3.52 20 3.52H4C3.86193 3.52 3.75 3.63342 3.75 3.77333V15.4267H2.25V3.77333Z" }, null, -1);
const _hoisted_3 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M0.8 16.9467C0.358172 16.9467 0 17.3096 0 17.7573C0 19.5482 1.43269 21 3.2 21H20.8C22.5673 21 24 19.5482 24 17.7573C24 17.3096 23.6418 16.9467 23.2 16.9467H0.8ZM1.65035 18.4667C1.91715 19.0642 2.51066 19.48 3.2 19.48H20.8C21.4893 19.48 22.0829 19.0642 22.3497 18.4667H1.65035Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_4 = /* @__PURE__ */ _createElementVNode("path", { d: "M13 7.06667V8.58667H15.1893L12 11.8185L9 8.77853L5.46967 12.3559L6.53033 13.4307L9 10.9281L12 13.9681L16.25 9.66147V11.88H17.75V7.06667H13Z" }, null, -1);
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_5);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/SalesAnalysis.vue"]]);
